import { WidgetCatalogEntry } from './ExtensionWidgetFields'

export const EXTENSION_BRIDGE_VERSION = '1.0.0'

export type ExtensionCatalogEntry = WidgetCatalogEntry

export interface ExtensionItemSpec {
    type: string
    text?: string
    name?: string
    fields?: { [name: string]: any }
}

export interface ExtensionStepSummary {
    id: string
    order: number
    name: string
    widgetTypes: string[]
}

export interface ExtensionContext {
    ready: boolean
    reason?: string
    app: string
    version: string
    workflowId?: string
    workflowName?: string
    mode?: string
    selectedLang?: string
    languages?: string[]
    steps?: ExtensionStepSummary[]
    supportedItemTypes?: string[]
}

export interface ExtensionPingResult {
    ok: boolean
    app: string
    version: string
    ready: boolean
    reason?: string
}

export interface ExtensionAddResult {
    ok: boolean
    error?: string
    stepId?: string
    itemType?: string
}

export interface ExtensionProvider {
    getContext(): ExtensionContext
    getCatalog(): ExtensionCatalogEntry[]
    addItem(spec: ExtensionItemSpec): ExtensionAddResult | Promise<ExtensionAddResult>
}
